<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('edit_broker') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                         <label for="name" class="required"> Name </label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="name"
                            placeholder="Packer name"
                        />
                        <br>
                        <label for="description">Description</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="description"
                            placeholder="Description"
                        />
                        <br>
                        <label for="fda">Fda</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="fda"
                            placeholder="Fda"
                        />
                        <label for="fax">Fax</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="fax"
                            placeholder="fax"
                        />
                        <label for="email">Email</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="email"
                            placeholder="email"
                        />
                        <label for="phone">Phone</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="phone"
                            placeholder="phone"
                        />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import {getBroker} from './api/api';

export default {
    name: "AddCity",
    props :{
        broker_id: {
            type: String|Number,
            default: null
        },
    },
    data() {
        return {
            id : "",
            name : "",
            description : "",
            fda : "",
            fax : "",
            email : "",
            phone : "",
        };
    },
    methods: {
        submit() {
             if (this.name === '') {
                this.$toastr.e('Name is required');
                return;
            }
            const data = {
                id : this.id,
                Second_Title : this.name,
                Title : this.name,
                description : this.description,
                fda : this.fda,
                fax : this.fax,
                Email : this.email,
                phone : this.phone,
            }
            this.$emit("save", data);
        },

        async getData(id) {
            const res = await getBroker(id);
            if (res.data) {
                const data = res.data;
                this.id = id;
                this.name = data.Second_Title;
                this.description = data.description;
                this.fda = data.fda;
                this.fax = data.fax;
                this.email = data.Email;
                this.phone = data.phone;
            }
        }
    },
    mounted(){
        if (this.broker_id) {
            this.getData(this.broker_id);
        }
    }
};
</script>
  